import { Component, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-popout-tab-buttons',
  imports: [TranslatePipe],
  templateUrl: './popout-tab-buttons.html',
  styleUrl: './popout-tab-buttons.scss',
})
export class PopoutTabButtons {
  public tabButtons = input.required<{ key: string; translationLabel: string }[]>();
  public activeTabButtonKey = model<string | null>();
}
